<template>
  <div v-if="isOpen" class="modal-backdrop">
    <div class="modal-container" @click.stop>
      <div class="modal-content" ref="modalContent">
        <EventDetail
          :categoryId="serchCategoryId"
          :contentsId="serchContentsId"
          :isPreview="true"
        />
      </div>
    </div>
    <div class="button-container">
      <button @click="handleClose">閉じる</button>
      <button id="com_pagetop1" @click="scrollToTop">
        <!-- ボタンの内容 -->
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, nextTick } from "vue";
import EventDetail from "../forms/EventDetailComponent.vue";
import { outputDebugLogs } from "@/Common";
export default defineComponent({
  name: "EventPreviewComponent",
  components: {
    EventDetail,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    categoryId: {
      type: String,
      required: true,
    },
    contentsId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const serchCategoryId = ref(props.categoryId || "");
    const serchContentsId = ref(props.contentsId || "");
    const modalContent = ref<HTMLElement | null>(null);

    const scrollToTop = () => {
      outputDebugLogs("scrollToTop called");
      outputDebugLogs("modalContent.value:" + modalContent.value);
      if (modalContent.value) {
        modalContent.value.scrollTop = 0;
        outputDebugLogs("scrollTop set to 0");
      } else {
        outputDebugLogs("modalContent.value is null");
      }
    };

    onMounted(() => {
      nextTick(() => {
        outputDebugLogs("onMounted: nextTick");
        serchCategoryId.value = props.categoryId || "";
        serchContentsId.value = props.contentsId || "";
        outputDebugLogs("modalContent:" + modalContent.value);
      });
    });

    return {
      serchCategoryId,
      serchContentsId,
      modalContent,
      scrollToTop,
    };
  },
  emits: ["closePreview"],
  methods: {
    handleClose() {
      this.$emit("closePreview", true);
    },
  },
});
</script>
<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: white;
  padding: 0px;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%; /* モーダルの幅を設定 */
  height: 100%;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
}

.modal-content {
  flex: 1; /* 残りのスペースを占める */
  border-width: 0px;
  /*margin: 0 auto;*/ /* 中央寄せ */
  margin: 0; /* 中央寄せのマージンを削除 */
  flex-direction: column;
  display: flex;
  overflow-y: auto; /* モーダル内でスクロールを有効にする */
  text-align: left; /* 左揃えに変更 */
  margin-bottom: 70px;
}

.modal-message {
  margin-top: 10%;
  margin-bottom: auto; /* ボタンの上までスペースを広げる */
  font-size: 1.5em; /* フォントサイズを大きくする */
  text-align: center;
  flex-grow: 1; /* メッセージ部分を伸ばして中央に配置 */
  display: flex;
  justify-content: center;
  white-space: pre-line; /* 改行を反映 */
}

.button-container {
  display: flex;
  justify-content: space-between; /* ボタンの間隔を広げる */
  width: 100%;
  padding: 0 20px; /* モーダルフォームの両側に余白を作成 */
  position: absolute;
  bottom: 30px; /* モーダルフォームの下辺からの距離 */
}

button {
  margin: 0 10px; /* 上下のマージンは0、左右のマージンを10pxに設定 */
  width: 150px;
  height: 40px;
  border-radius: 10px;
}
</style>
